var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.06348 17.6382V24.4361H10.7495C11.8541 24.4361 12.7495 23.5406 12.7495 22.4361V15.6382H6.06348C4.95888 15.6382 4.06348 16.5337 4.06348 17.6382Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3513 7.94096L18.9742 3.56396L14.6708 7.86716C13.8897 8.64836 13.8897 9.91456 14.6708 10.6958L19.0479 15.0728L23.3513 10.7691C24.1324 9.98826 24.1324 8.72216 23.3513 7.94096Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7495 4.92188H4.06348V11.7198C4.06348 12.8248 4.95888 13.7198 6.06348 13.7198H12.7495V6.92188C12.7495 5.81737 11.8541 4.92188 10.7495 4.92188Z",
    fill: "#00DEA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.353 15.6382H14.667V22.4361C14.667 23.5406 15.5624 24.4361 16.667 24.4361H23.353V17.6382C23.353 16.5337 22.4576 15.6382 21.353 15.6382Z",
    fill: "#00DEA0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.b3d6edbb894f987f82e1a52cd1a36bd7.svg";
export { ForwardRef as ReactComponent };